import { isNotDefined } from '@mntn-dev/utilities'

import { generateTextFromJsonString } from './generate-text.ts'

export const isRichTextEmpty = (jsonString: string | null | undefined) => {
  if (isNotDefined(jsonString)) {
    return true
  }

  const text = generateTextFromJsonString(jsonString)
  return text.length === 0
}
